import * as shvl from 'shvl'
import VueClipboard from 'vue-clipboard2'
import {normalizeDate} from '../utils/dateHelpers'
import pluralize from 'pluralize'
import store from '../store'

export const componentIs = col => {
  if (col.icon) {
    return 'grid-cell-icon'
  }
  if (col.relation) {
    return col.relation.type === 'one' ? 'grid-cell-relation-one' : 'grid-cell-relation-many'
  }
  if (col.repeat) {
    return 'grid-cell-repeat'
  }
  if (col.type === 'custom' && col.render) {
    return col.render
  }
  if (col.type === 'action') {
    return col.field === 'action_delete' ? 'grid-cell-action-delete' : 'grid-cell-action-edit'
  }
  return col.type ? `grid-cell-${col.type}` : 'grid-cell-string'
}

export const deepPath = (obj, path, defaultValue) => {
  if (obj && path) {
    const v = shvl.get(obj, path, '')
    return v !== undefined && v !== null ? v : defaultValue || ''
  }
  return defaultValue || ''
}

export const columnDefaultValue = (row, column) => {
  // console.log('columnDefaultValue', row, column)
  if (column && row) {
    const { field, relation, type, defaultValue } = column
    if (field) {
      const value = row[field]
      // -- boolean
      if (type === 'boolean') {
        if (value === false || value === true) {
          return value
        }
        if (value === 1) {
          return true
        }
        if (value === 0) {
          return false
        }
        // console.log('columnDefaultValue defaultValue', defaultValue)
        return defaultValue || null
      }
      if (type === 'number') {
        if (value || value === 0 || value > 0 || value < 0) {
          // console.log('columnDefaultValue number', value)
          return value
        }
        // console.log('columnDefaultValue number', null)
        return null
      }
      if (column.component && column.component.is && column.component.is === 'q-editor') {
        if (!value) {
          return ''
        }
        // console.log('column.component.is', row, column, value)
      }
      // relation
      if (relation) {
        if (relation.type === 'one') {
          if (value) {
            return value
          }
          return defaultValue || null
        }
        if (relation.type === 'many') {
          if (value === undefined) {
            return []
          }
          if (Array.isArray(value)) {
            return value
          }
          return defaultValue || []
        }
      }
      // everything else
      return shvl.get(row, field, defaultValue || null)
    }
  }
  return ''
}

export const mapKeys = (list = [], key = 'id') => {
  if (!Array.isArray(list)) {
    return []
  }
  return list.map(row => {
    if (typeof row === 'object' && row !== null && row !== undefined) {
      return row[key]
    }
    if (typeof row === 'number' || typeof row === 'string') {
      return row
    }
  })
}

export const getObjectValue = (obj, label, debug) => {
  if (debug) {
    console.log('getObjectValue obj', obj, 'label', label)
  }
  if (!label || !obj || typeof obj !== 'object') {
    if (debug) {
      console.log('return 1 obj', obj)
    }
    return obj
  }
  if (typeof label === 'function') {
    try {
      if (debug) {
        console.log('return 2 label.call(obj, obj)', label.call(obj, obj))
      }
      return label.call(obj, obj)
    } catch (e) {
      console.log('ERROR: getObjectValue function: ', e)
    }
  }
  try {
    if (debug) {
      console.log('return 2 shvl.get(obj, label)', shvl.get(obj, label))
    }
    return shvl.get(obj, label)
  } catch (e) {
    console.log('ERROR: getObjectValue shvl: ', e)
  }
}

export const relationLabel = (value, column, parentColumn = undefined) => {
  let labelField = column ? column.displayValue || column.field : undefined

  let debug = false
  // if (column && column.name && column.name === 'cityStateZip') {
  //   debug = true
  //   console.log('relationLabel', 'value', value, 'column', column, 'parentColumn', parentColumn, 'labelField', labelField)
  // }

  let parsedValue = ''
  if (value !== null && value !== undefined && labelField) {
    if (typeof labelField !== 'string') {
      if (column.relation && column.deepDisplay) {
        labelField = column.deepDisplay
      }
    }
    if (typeof value === 'object') {
      parsedValue = getObjectValue(value, labelField, debug)
      // if (debug) {
      //   console.log('parsedValue 1', parsedValue)
      // }
      if (parsedValue !== null && parsedValue !== undefined && typeof parsedValue === 'object') {
        if (column.relation && column.relation.namespace) {
          const ns = column.relation.namespace
          const relationTitleColumn = store.getters[`${ns}/titleColumn`]
          if (relationTitleColumn) {
            if (relationTitleColumn.displayValue && typeof relationTitleColumn.displayValue === 'function') {
              return relationTitleColumn.displayValue(parsedValue, value)
            }
            parsedValue = getObjectValue(parsedValue, relationTitleColumn.field, debug)
            // if (debug) {
            //   console.log('parsedValue 2', parsedValue)
            // }
          }
        }
      }
    } else if (Array.isArray(value)) {
      parsedValue = value.map(v => getObjectValue(v, labelField), debug)
      // if (debug) {
      //   console.log('parsedValue 3', parsedValue)
      // }
    }
  }
  // if (column && column.name && column.name === 'cityStateZip') {
  //   console.log('parsedValue 2', parsedValue)
  // }
  return parsedValue
}

export const qOptions = (data, labelField = 'name', valueField = 'id') => {
  return data.map(r => {
    let label = ''
    if (typeof labelField === 'function') {
      label = labelField.call(this, r)
    } else {
      label = r[labelField] ? r[labelField].toString() : '(no label)'
    }
    return {
      label,
      value: r[valueField]
    }
  })
}

export const toSingular = value => {
  return pluralize.singular(value)
}
export const toPlural = value => {
  return pluralize.plural(value)
}

export const dateFormat = (d, format) => {
  return normalizeDate(d, format || 'MMM D YYYY h:mm a')
}

export const columnSize = column => {
  if (column.component && column.component.is === 'q-editor') {
    return 'col-12'
  }
  if (column.relation && column.relation.type === 'many') {
    return 'col-12'
  }
  return 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'
}

export const fieldHelper = (column, errors) => {
  return errors.has(column.name) ? errors.first(column.name) : column.description
}
export const fieldIcon = (column, errors, scope) => {
  let icon = column.icon || 'edit'
  if (column.component && column.component.validation && column.component.validation.required) {
    icon = errors.has(column.name, scope) ? 'star_border' : 'star'
  }
  return icon
}

export const disabledColumn = column => {
  if (column.roles && column.roles.length) {
    return !store.getters['auth/hasAnyRole'](column.roles)
  }
  return false
}
export const toMoney = (value, sign = '$') => {
  if (value !== null && value !== undefined && typeof value === 'number') {
    return `${sign}${value.toFixed(2)}`
  }
  return `${sign}0.00`
}

export default ({ Vue }) => {
  Vue.filter('columnSize', columnSize)
  Vue.filter('componentIs', componentIs)
  Vue.filter('shvl', deepPath)
  Vue.filter('qOptions', qOptions)
  Vue.filter('dateFormat', dateFormat)
  Vue.filter('mapKeys', mapKeys)
  Vue.filter('disabledColumn', disabledColumn)
  Vue.filter('fieldIcon', fieldIcon)
  Vue.filter('fieldHelper', fieldHelper)
  Vue.filter('money', toMoney)
  Vue.filter('singular', toSingular)
  Vue.filter('plural', toPlural)
  Vue.filter('relationLabel', relationLabel)
  Vue.filter('columnDefaultValue', columnDefaultValue)
  Vue.use(VueClipboard)
}
